import type { ApiRoutes } from '@tempo-io/integration-credentials-app/rpc';
import { hc } from 'hono/client';
import type { KyInstance } from 'ky';

export const getIntegrationCredentialsMergeDevApi = ({
  prefixUrl = '',
  client,
}: {
  prefixUrl?: string;
  client: KyInstance;
}) =>
  hc<ApiRoutes>('/api/integration-credentials/v1/merge-dev/', {
    fetch: (input: RequestInfo | URL, requestInit?: RequestInit) => {
      return client(`${prefixUrl}${input}`, {
        method: requestInit?.method,
        headers: {
          'content-type': 'application/json',
          ...requestInit?.headers,
        },
        body: requestInit?.body,
      });
    },
  });
